import React, { useEffect, useState } from "react";
import { Box, Link } from "@mui/material";
import { useApi } from "../../utils/api";

const IG_URL = "https://www.instagram.com/trainerxapp/";

/** Comma-separated image URLs (CDN) shown when instagram/public-feed is unavailable */
function legacyFooterImageFallback() {
  const raw = import.meta.env.VITE_FOOTER_INSTAGRAM_IMAGES;
  if (!raw || typeof raw !== "string") return [];
  return raw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .slice(0, 4)
    .map((media_url, i) => ({
      id: `footer-ig-fallback-${i}`,
      media_url,
      permalink: IG_URL,
      media_type: "IMAGE",
    }));
}

export default function FooterInstagramPosts() {
  const { getPublicInstagramFeed } = useApi();
  const [items, setItems] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const j = await getPublicInstagramFeed(4);
        if (cancelled) return;
        let list = Array.isArray(j?.data) ? j.data : [];
        if (list.length === 0) {
          list = legacyFooterImageFallback();
        }
        setItems(list);
      } catch {
        if (!cancelled) {
          const fb = legacyFooterImageFallback();
          setItems(fb.length ? fb : []);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [getPublicInstagramFeed]);

  if (items === null || items.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: { xs: 1.5, sm: 2 },
        justifyContent: "center",
        maxWidth: { xs: "100%", sm: 580, md: 640 },
        mx: "auto",
        mt: 0.5,
        px: { xs: 1, sm: 0 },
      }}
    >
      {items
        .map((m) => {
          const src =
            m.media_type === "VIDEO"
              ? m.thumbnail_url || m.media_url
              : m.media_url;
          if (!src) return null;
          return (
            <Link
              key={m.id}
              href={m.permalink || IG_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "block",
                width: { xs: 108, sm: 128, md: 140 },
                flexShrink: 0,
                borderRadius: 1,
                overflow: "hidden",
                boxShadow:
                  "0 2px 8px rgba(0,0,0,0.12), inset 0 0 0 1px rgba(0,0,0,0.06)",
                lineHeight: 0,
                "& img": {
                  width: "100%",
                  aspectRatio: "1 / 1",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img
                src={src}
                alt={
                  m.caption
                    ? m.caption.slice(0, 120)
                    : "Trainer App on Instagram"
                }
                referrerPolicy="no-referrer"
              />
            </Link>
          );
        })
        .filter(Boolean)}
    </Box>
  );
}
